import { Suspense, useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { EffectComposer, Bloom, Noise, Vignette } from '@react-three/postprocessing';
import { LavaLamp } from './components/LavaLamp';

export default function App() {
  const dpr = useMemo(() => {
    const max = window.devicePixelRatio || 1;
    return Math.min(2, Math.max(1.25, max));
  }, []);

  return (
    <div className="app-root">
      <Canvas
        className="background-canvas"
        dpr={dpr}
        gl={{ antialias: true, powerPreference: 'high-performance' }}
        camera={{ position: [0, 0, 1], near: 0.01, far: 10 }}
        orthographic
      >
        <color attach="background" args={['#0b0b0f']} />
        <Suspense fallback={null}>
          <LavaLamp />
          <EffectComposer multisampling={0}>
            <Bloom intensity={0.6} mipmapBlur luminanceThreshold={0.15} />
            <Noise premultiply opacity={0.08} />
            <Vignette eskil={false} offset={0.2} darkness={0.9} />
          </EffectComposer>
        </Suspense>
      </Canvas>

      <div className="overlay">
        <div className="brand">Orchestra Labs</div>
        <div className="tagline">
          <span className="line">Think in a new dimension.</span>
          <span className="line">Solving the hardest problems in national security.</span>
        </div>
      </div>
    </div>
  );
}


